import { UrgentFollowUpTabs } from '@pages/urgentfollowups/types';
import { SecondChanceLeadsFilters } from '../hooks/useSecondChanceLeadsFilters';
import {
  SecondChanceLeadFollowUpFilterInput,
  SecondChanceLeadStatus,
} from '@api/generated/graphql';
import { daysToMilliseconds } from '@lib/utils/time';

const openSCLStatuses = [
  SecondChanceLeadStatus.New,
  SecondChanceLeadStatus.LeadCallbackAttempted,
];

const coldSCLStatuses = [...openSCLStatuses];

export const doneSCLStatuses = [
  SecondChanceLeadStatus.LeadNotAbleToSave,
  SecondChanceLeadStatus.LeadNotFollowingUp,
  SecondChanceLeadStatus.ReviewedNotALead,
  SecondChanceLeadStatus.JobBookedByScl,
  SecondChanceLeadStatus.JobBookedElsewhere,
  SecondChanceLeadStatus.Expired,
];

export const getStatusFilters = (
  tab: UrgentFollowUpTabs,
): SecondChanceLeadStatus[] => {
  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return openSCLStatuses;
    case UrgentFollowUpTabs.Cold:
      return coldSCLStatuses;
    case UrgentFollowUpTabs.Done:
      return doneSCLStatuses;
  }
};

const getOpenSecondChanceLeadFilters = (
  daysUntilCold: number,
): Partial<SecondChanceLeadsFilters> => {
  const daysUntilColdInMS = daysToMilliseconds(daysUntilCold);

  return {
    fromDate: new Date(new Date().getTime() - daysUntilColdInMS),
  };
};

const getColdSecondChanceLeadFilters = (
  daysUntilCold: number,
): Partial<SecondChanceLeadsFilters> => {
  const daysUntilColdInMS = daysToMilliseconds(daysUntilCold);
  return {
    toDate: new Date(new Date().getTime() - daysUntilColdInMS),
  };
};

const getDoneSecondChanceLeadFilters =
  (): Partial<SecondChanceLeadsFilters> => {
    return {};
  };

export const getDefaultSecondChanceLeadFilters = (
  tab: UrgentFollowUpTabs,
  daysUntilCold: number,
): SecondChanceLeadsFilters => {
  const sclStatuses = getStatusFilters(tab);
  const filter: SecondChanceLeadsFilters = {
    sclStatuses,
    includeNullCallReasons: false,
  };

  switch (tab) {
    case UrgentFollowUpTabs.Open:
      return { ...filter, ...getOpenSecondChanceLeadFilters(daysUntilCold) };
    case UrgentFollowUpTabs.Cold:
      return { ...filter, ...getColdSecondChanceLeadFilters(daysUntilCold) };
    case UrgentFollowUpTabs.Done:
      return { ...filter, ...getDoneSecondChanceLeadFilters() };
  }
};

export const getSecondChanceLeadsBadgeCountFilters = (
  daysUntilCold: number,
): SecondChanceLeadFollowUpFilterInput => {
  // If we don't floor to the nearest minute, the query perpetually
  // re-triggers, presumably due to the date's exact value changing on every
  // re-render.
  const fromDate = getOpenSecondChanceLeadFilters(daysUntilCold).fromDate;

  fromDate?.setMilliseconds(0);
  fromDate?.setSeconds(0);

  return {
    fromDate,
    // For the badge count we want *new* open second chance leads.
    secondChanceLeadStatuses: [SecondChanceLeadStatus.New],
  };
};
